var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeterPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 157,
    viewBox: "0 0 20 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88546 0.320312L18.9592 149.552H0.811743L9.88546 0.320312Z",
    fill: "#395BA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7466 146.265C19.7466 151.711 15.3316 156.126 9.88546 156.126C4.43932 156.126 0.024353 151.711 0.024353 146.265C0.024353 140.819 4.43932 136.404 9.88546 136.404C15.3316 136.404 19.7466 140.819 19.7466 146.265Z",
    fill: "#395BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeterPin);
export default __webpack_public_path__ + "static/media/meter-pin.f7ae12e7ae20224d59f522cb1340d575.svg";
export { ForwardRef as ReactComponent };